import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Production module landing page.
 *
 * Owner (2026-10-05): the department pages list the modules the team uses and the KPI
 * reports that matter to it (DeptLandingSections); each card shows only when the person
 * may open it. The route is gated by dept.production in allRoutes.js.
 */
const TOOLS = [
    "displayBoards", "di", "mafia", "tasks", "tasksDept", "tasksActivity",
    "whosIn", "dmsAll", "epoCreate", "toolTracker",
];
const REPORTS = ["summary-otd", "blown-up-otd", "dmr-performance-quality", "backlog-orders"];

const Production = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-tools-line"
                        eyebrow="Shop Floor"
                        title="Production"
                        subtitle="Shop floor activity and run-rate insights"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Production" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Production tools"
                        description="Live boards, inspection, tasks and who is in"
                        icon="ri-tools-line"
                    />
                    <DeptReportsGrid ids={REPORTS} />

                    <ComingSoonCard
                        compact
                        icon="ri-tools-line"
                        title="More for Production later"
                        message="Ideas for later: hourly run-rate by machine, downtime causes and shift summaries. The cards above are live today."
                        tone="success"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Production;
